import { PraksisstedUndernodeDto } from '../api/generated/praksissted-generated-api';

export const flattenPraksisstedUndernodeDto = (
  undernode: PraksisstedUndernodeDto,
): PraksisstedUndernodeDto[] =>
  [undernode].concat(undernode.under.flatMap(flattenPraksisstedUndernodeDto));
